import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/travel',
    name: 'Travel',
    component: () => import('../views/Travel.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/events',
    name: 'Events',
    component: () => import('../views/Events.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/registry',
    name: 'Registry',
    component: () => import('../views/Registry.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/faqs',
    name: 'FAQs',
    component: () => import('../views/FAQs.vue'),
    meta: {
      requiresAuth: true
    }
  },
  // {
  //   path: '/rsvp',
  //   name: 'RSVP',
  //   component: () => import('../views/RSVP.vue'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  {
    path: '*',
    component: Home,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      next('/')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView();
  },
  routes
})

router.beforeEach((to, from, next) => {
  let routeRequiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if(routeRequiresAuth) {
    const hasMeatloaf = document.cookie.split('=')[1]

    if (hasMeatloaf === "true") {
      return next()
    } else {
      return next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    return next()
  }
})

export default router
